import { parseBoatNamesSnapshot, type BoatNamesSnapshot } from '@neomaris/protocol';
import { useEffect, useState } from 'react';

import { api } from '../api';
import { NEO_NAMES_UPDATED_EVENT } from './neoNames';

export const BOAT_NAMES_CHANGED_EVENT = 'nm:boat-names-changed';

export function useBoatNamesRevision(boatId: string): number {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const changed = (event: Event) => {
      if ((event as CustomEvent<{ boatId: string }>).detail?.boatId === boatId) {
        setRevision((value) => value + 1);
      }
    };
    window.addEventListener(BOAT_NAMES_CHANGED_EVENT, changed);
    window.addEventListener(NEO_NAMES_UPDATED_EVENT, changed);
    return () => {
      window.removeEventListener(BOAT_NAMES_CHANGED_EVENT, changed);
      window.removeEventListener(NEO_NAMES_UPDATED_EVENT, changed);
    };
  }, [boatId]);
  return revision;
}

export function useBoatNames(boatId: string, revision: number): BoatNamesSnapshot | null {
  const [names, setNames] = useState<BoatNamesSnapshot | null>(null);
  useEffect(() => setNames(null), [boatId]);
  useEffect(() => {
    if (boatId === '') return;
    let active = true;
    void api(`/v1/boats/${boatId}/names`).then(
      (raw) => {
        const next = parseBoatNamesSnapshot(raw);
        if (active && next?.boatId === boatId) setNames(next);
      },
      () => {}
    );
    return () => {
      active = false;
    };
  }, [boatId, revision]);
  return names;
}
